import React from 'react';
import { Link } from 'react-router-dom';

import PublicLayout from '../common/PublicLayout';

function Register() {
  return (
    <PublicLayout title="Register">
      <div className="max-w-md mx-auto">
        <div className="bg-white/5 rounded-lg p-8">
          <h2 className="text-xl font-bold text-white mb-6">Choose Your Membership Type</h2>

          <div className="space-y-4">
            <Link
              to="/membership/register?type=full"
              className="block p-4 bg-white/10 rounded-lg hover:bg-white/15 transition-colors"
            >
              <h3 className="text-lg font-semibold text-white mb-2">Full Membership</h3>
              <p className="text-gray-400">Access to all club facilities and events</p>
            </Link>

            <Link
              to="/membership/register?type=family"
              className="block p-4 bg-white/10 rounded-lg hover:bg-white/15 transition-colors"
            >
              <h3 className="text-lg font-semibold text-white mb-2">Family Membership</h3>
              <p className="text-gray-400">Include your family members in club activities</p>
            </Link>

            <Link
              to="/membership/register?type=junior"
              className="block p-4 bg-white/10 rounded-lg hover:bg-white/15 transition-colors"
            >
              <h3 className="text-lg font-semibold text-white mb-2">Junior Membership</h3>
              <p className="text-gray-400">For members under 21 years of age</p>
            </Link>
          </div>

          <p className="mt-6 text-center text-sm text-gray-400">
            Already have an account?{' '}
            <Link to="/login" className="text-hdlcc-lightBlue hover:text-hdlcc-blue">
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}

export default Register;
